import React from 'react'
import update from 'immutability-helper';
import Modal from 'react-modal';
import { browserHistory } from 'react-router'

import { billing } from '../../core/controllers/Billing';
import { modal } from '../../core/utilities/modal';
import { modalStyles } from '../../core/controllers/ModalStyles';
import { SelectableCard } from '../../helpers/Cards/SelectableCard';

export default class AddBankAccountForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            institutions: [],
            filteredInstitutions: [],
            bankName: '',
            searchString: '',
            selectedInstitution: '0',
            bankingForm: null,
            username: '',
            password: '',
            showModal: false,
            addBankAccountDisabled: true,
            bankAccounts: [],
            mfa: [],
            selectedBankAccount: '0',
            displayInstitutions: 'none',
            bankAccountType: 'CHECKING',
            selectedMFA: [],
            instantVerification: true,
            routing: '',
            account: '',
            usernameAttribute: '',
            passwordAttribute: ''
        };

        this.mfaTextAnswers = [];
    }

    componentDidMount() {
        var self = this;
        billing.getInstitutions(function(response) {
            self.setState({
                institutions: response.data.institutions,
                filteredInstitutions: response.data.institutions
            });
        })
    }

    authInstitution() {
        var self                = this;

        const username          = this.state.username;
        const password          = this.state.password;
        const institutionId     = this.state.selectedInstitution;
        const usernameAttribute = this.state.usernameAttribute;
        const passwordAttribute = this.state.passwordAttribute;

        if(username == '' || typeof username == 'undefined') {
            modal.showInfo("Enter a username.", "warning", "top", "center");
            return;
        }
        if(password == '' || typeof password == 'undefined') {
            modal.showInfo("Enter a password.", "warning", "top", "center");
            return;
        }
        if(institutionId == '' || typeof institutionId == 'undefined') {
            modal.showInfo("Unable to find your institution, try again.", "warning", "top", "center");
            return;
        }

        var data = {
            institution_id: institutionId
        }

        data[usernameAttribute] = username;
        data[passwordAttribute] = password;

        billing.authInstitution(data, function(response) {
            if (response.data.hasOwnProperty('accounts')) {
                self.setState({
                    bankAccounts: response.data.accounts
                });
            } else if (response.data.hasOwnProperty('mfa')) {
                self.setState({
                    mfa: response.data.mfa
                });
            }
        });
    }

    addBankAccount() {
        var self                  = this;
        const selectedBankAccount = this.state.selectedBankAccount;
        const bankAccountType     = this.state.bankAccountType;
        const bankAccounts        = this.state.bankAccounts;
        const bankName            = this.state.bankName;
        const instantVerification = this.state.instantVerification;
        const routing             = this.state.routing;
        const account             = this.state.account;
        var choosenBankAccount    = [];

        if (instantVerification) {
            choosenBankAccount  = bankAccounts.filter((bank) => {
                if (bank.account == selectedBankAccount) {
                    return bank;
                }
            });
            if(choosenBankAccount == null && choosenBankAccount.length == 0) {
                modal.showInfo("You have not selected a bank account to add.", "warning", "top", "center");
                return;
            }
        } else {
            if(routing.length == 0) {
                modal.showInfo("Enter the routing number.", "warning", "top", "center");
                return;
            }
            if(account.length == 0) {
                modal.showInfo("Enter the account number.", "warning", "top", "center");
                return;
            }
        }

        if(bankName == '') {
            modal.showInfo("Enter a bank label for this account.", "warning", "top", "center");
            return;
        }

        const bankAccount = {
            type: bankAccountType,
            routing: choosenBankAccount.length > 0 ? choosenBankAccount[0].routing : routing,
            account: choosenBankAccount.length > 0 ? choosenBankAccount[0].account : account,
            bankName: bankName,
            instantVerification: instantVerification
        }

        if (instantVerification) {
            this.sendAddBankRequest(bankAccount);
        } else {
            modal.showDangerModalWithOK("Warning!","You are about to link this bank account.  We'll need to deposit two small amounts within the next 1 - 2 business days to verify.  Please come back here to enter the amounts in order to verify and start using this account.  Continue?","Yes");
            jQuery(".move-on").on('click',function() {
                self.sendAddBankRequest(bankAccount);
            });
        }
    }

    sendAddBankRequest(bankAccount) {
        var self = this;
        billing.addBankAccount(bankAccount, function(response) {
            if (response.status == 'OK') {
                modal.showInfo("Your bank account has been successfully linked!  You can now add another bank account.", "success", "top", "center");
                self.refresh();
                browserHistory.goBack();
            }
        });
    }

    processMFA(e) {
        var self                  = this;
        const selectedMFA         = this.state.selectedMFA;
        const selectedInstitution = this.state.selectedInstitution;
        const mfa                 = this.state.mfa;

        if (typeof selectedMFA != "string") {
            if (selectedMFA.length != mfa.length) {
                modal.showInfo("Please finish the security question(s).", "warning", "top", "center");
                return;
            }
        }

        const mfaData = {
            mfa: Array({
                type: mfa[0].type,
                name: mfa[0].name,
                description: mfa[0].description,
                response: selectedMFA
            }),
            institution_id: selectedInstitution
        }

        billing.processMFA(mfaData, function(response) {
            if (response.status == 'OK') {
                if (response.data.hasOwnProperty('accounts')) {
                    self.setState({
                        bankAccounts: response.data.accounts,
                        mfa: []
                    });
                } else if (response.data.hasOwnProperty('mfa')) {
                    self.setState({
                        mfa: response.data.mfa
                    });
                } else {
                    self.handleCloseModal(false);
                }
            }
        });
    }

    processSelectionMFA(e) {
        var self                  = this;
        const selectedInstitution = this.state.selectedInstitution;
        const mfa                 = this.state.mfa;
        const selectedMFA         = this.state.selectedMFA;
        var failed                = false;
        var answerArray           = [];
        if (typeof selectedMFA != "string") {
            if (selectedMFA.length != mfa.length) {
                modal.showInfo("Please finish the security question(s).", "warning", "top", "center");
                return;
            }
        }

        selectedMFA.map((response, index) => {
            answerArray.push({
                description: mfa[index].description,
                name: mfa[index].name,
                type: mfa[index].type,
                response: response
            });
        });

        if(failed) {
            modal.showInfo("Please finish the security question(s).", "warning", "top", "center");
            return;
        }

        var mfaData = {
            mfa: answerArray,
            institution_id: selectedInstitution
        }

        billing.processMFA(mfaData, function(response) {
            if (response.status == 'OK') {
                if (response.data.hasOwnProperty('accounts')) {
                    self.setState({
                        bankAccounts: response.data.accounts,
                        mfa: []
                    });

                    self.mfaTextAnswers = [];
                } else if (response.data.hasOwnProperty('mfa')) {
                    self.setState({
                        mfa: response.data.mfa
                    });
                } else {
                    self.handleCloseModal(false);
                }
            }
        });
    }

    processMFAQuestions(e) {
        var self                  = this;
        const selectedInstitution = this.state.selectedInstitution;
        const mfa                 = this.state.mfa;
        const keys                = Object.keys(this.mfaTextAnswers);
        var failed                = false;
        var answerArray           = [];
        mfa.map((challenge, index) => {
            var found = false;
            keys.map((key, index) => {
                if (challenge.name == self.mfaTextAnswers[key].name && self.mfaTextAnswers[key].response != "") {
                    found = true;
                }
            });

            if (!found) {
                failed = true;
            }
        });

        keys.map((key, index) => {
            answerArray.push({
                description: self.mfaTextAnswers[key].description,
                name: self.mfaTextAnswers[key].name,
                type: self.mfaTextAnswers[key].type,
                response: self.mfaTextAnswers[key].response
            });
        });

        if(failed) {
            modal.showInfo("Please finish the security question(s).", "warning", "top", "center");
            return;
        }

        var mfaData = {
            mfa: answerArray,
            institution_id: selectedInstitution
        }

        billing.processMFA(mfaData, function(response) {
            if (response.status == 'OK') {
                if (response.data.hasOwnProperty('accounts')) {
                    self.setState({
                        bankAccounts: response.data.accounts,
                        mfa: []
                    });

                    self.mfaTextAnswers = [];
                } else if (response.data.hasOwnProperty('mfa')) {
                    self.setState({
                        mfa: response.data.mfa
                    });
                } else {
                    self.handleCloseModal(false);
                }
            }
        });
    }

    /* ACH Information */
    handleBankNameChange(e){
        this.setState({
            bankName: e.target.value
        });
    }

    filterInstitutions(e) {
        const value = e.target.value.toLowerCase();

        const filteredInstitutions = this.state.institutions.filter((bank) => {
            if (bank.name.toLowerCase().includes(value)) {
                return bank;
            }
        });

        this.setState({
            searchString: value,
            filteredInstitutions: filteredInstitutions,
            bankingForm: null,
            displayInstitutions: 'block'
        });
    }

    selectedInstitutionChange(bank) {
        this.setState({
            selectedInstitution: bank.id,
            bankingForm: bank,
            showModal: !this.state.showModal,
            searchString: bank.name,
            displayInstitutions: 'none'
        });
    }

    handleUsernameChange(attributeName, e) {
        this.setState({
            username: e.target.value,
            usernameAttribute: attributeName
        });
    }

    handlePasswordChange(attributeName, e) {
        this.setState({
            password: e.target.value,
            passwordAttribute: attributeName
        });
    }

    handleCloseModal(confirmWithUser) {
        var self = this
        if (confirmWithUser == true) {
            modal.showDangerModalWithOK("Cancel Process", "Are you sure you want to cancel this process?", "Cancel");
            jQuery(".move-on").on('click',function() {
                self.refresh();
            });
        } else {
            this.setState({
                showModal: !this.state.showModal,
                selectedInstitution: '0'
            })
        }
    }

    selectBankAccount(e) {
        this.setState({
            selectedBankAccount: e.target.value
        });
    }

    selectBankAccountType(e) {
        this.setState({
            bankAccountType: e.target.value
        });
    }

    didSelectAccount() {
        if (this.state.selectedBankAccount == "0") {
            modal.showInfo("Please select an account!", "danger", "top", "center");
        } else {
            this.setState({
                addBankAccountDisabled: false
            });

            this.handleCloseModal(false);
        }
    }

    changeSelectedMFA(mfaQuestionsCount, e) {
        var newSelectedMFA = this.state.selectedMFA
        newSelectedMFA[mfaQuestionsCount] = e.target.value

        this.setState({
            selectedMFA: newSelectedMFA
        });
    }

    handleAnswerChange(challenge, e) {
        if (challenge.type == 'IMAGE') {
            this.setState({
                selectedMFA: e.target.value
            });
        }
        else {
            if(typeof this.mfaTextAnswers[challenge.name] === 'undefined') {
                var newChallenge = challenge;
                newChallenge.response = e.target.value;
                this.mfaTextAnswers[challenge.name] = newChallenge;
            } else {
                this.mfaTextAnswers[challenge.name].response = e.target.value;
            }
        }
    }

    individualSelected() {
        this.setState({
            instantVerification: true,
        });
    }

    companySelected() {
        this.setState({
            instantVerification: false
        });
    }

    handleAccountChange(e) {
        this.setState({
            account: e.target.value
        });
    }

    handleRoutingChange(e) {
        this.setState({
            routing: e.target.value
        });
    }

    refresh() {
        this.setState({
            bankName: '',
            searchString: '',
            selectedInstitution: '0',
            bankingForm: null,
            username: '',
            password: '',
            showModal: false,
            addBankAccountDisabled: true,
            bankAccounts: [],
            mfa: [],
            selectedBankAccount: '0',
            displayInstitutions: 'none',
            bankAccountType: 'CHECKING',
            routing: '',
            account: ''
        });
    }

    render(){
        var self                        = this;
        const bankName                  = this.state.bankName;
        const routing                   = this.state.routing;
        const account                   = this.state.account;
        const institutions              = this.state.filteredInstitutions;
        const searchString              = this.state.searchString;
        const bankingForm               = this.state.bankingForm;
        const username                  = this.state.username;
        const password                  = this.state.password;
        const showModal                 = this.state.showModal;
        var addBankAccountDisabled      = this.state.addBankAccountDisabled;
        const bankAccounts              = this.state.bankAccounts;
        const mfa                       = this.state.mfa;
        const selectedBankAccount       = this.state.selectedBankAccount;
        var displayInstitutions         = this.state.displayInstitutions;
        const bankAccountType           = this.state.bankAccountType;
        const selectedMFA               = this.state.selectedMFA;
        const instantVerification       = this.state.instantVerification;

        if (instantVerification == false && account.length > 0 && routing.length > 0 && bankName.length > 0) {
            addBankAccountDisabled = false;
        }

        const filteredOptionsHTML       = institutions.map((bank, index) => {
            return <li value={bank.id} key={index} onClick={self.selectedInstitutionChange.bind(self, bank)}>{bank.name}</li>
        });

        const bankAccountsHTML          = bankAccounts.map((account, index) => {
            return <option value={account.account} key={index}>{account.name} {account.account}</option>
        });

        const choosenBankAccount        = bankAccounts.filter((bank) => {
            if (bank.account == selectedBankAccount) {
                return bank;
            }
        });

        var optionsHTML = '';
        var mfaSubmitHTML = '';
        var mfaQuestionsCount = -1;
        const mfaHTML   = mfa.map((challenge, index) => {
            if (challenge.type == 'SELECTION') {
                optionsHTML = challenge.selections.map((selection, index) => {
                    return (
                        <option value={selection.name} key={index}>{selection.description}</option>
                    )
                });
                mfaSubmitHTML = (
                    <div class="col-md-12">
                        <button type="button" id="save-tenant" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill pull-right" autoComplete="off" onClick={this.processSelectionMFA.bind(this)}>
                        Submit
                        </button>
                        <div class="clearfix"></div>
                    </div>
                )
                mfaQuestionsCount += 1

                return (
                <div class="col-md-12 col-sm-12 col-xs-12" style={{paddingLeft: '0px'}}>
                    <div class="form-group">
                        <label for="phone">{challenge.description}</label>
                        <select class="form-control" value={selectedMFA[mfaQuestionsCount]} onChange={self.changeSelectedMFA.bind(self, mfaQuestionsCount)}>
                            <option value="0" key={"0"}>Choose an answer</option>
                            {optionsHTML}
                        </select>
                    </div>
                </div>
                )
            } else if (challenge.type == 'TEXT') {
                mfaSubmitHTML = (
                    <div class="col-md-12">
                        <button type="button" id="save-tenant" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill pull-right" autoComplete="off" onClick={this.processMFAQuestions.bind(this)}>
                        Submit
                        </button>
                        <div class="clearfix"></div>
                    </div>
                )

                return (
                <div class="col-md-12 col-sm-12 col-xs-12" style={{paddingLeft: '0px'}}>
                    <div class="form-group">
                        <label for="phone">{challenge.description}</label>
                        <input type="text" class="form-control tenant-info" name={challenge.name} placeholder="Answer to question" id="name" onChange={this.handleAnswerChange.bind(self, challenge)}/>
                    </div>
                </div>
                )
            } else if (challenge.type == 'IMAGE') {
                mfaSubmitHTML = (
                    <div class="col-md-12">
                        <button type="button" id="save-tenant" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill pull-right" autoComplete="off" onClick={this.processMFA.bind(this)}>
                        Submit
                        </button>
                        <div class="clearfix"></div>
                    </div>
                )

                return (
                <div class="col-md-12 col-sm-12 col-xs-12" style={{paddingLeft: '0px'}}>
                    <img src={challenge.image} width="100%"/>
                    <div class="form-group">
                        <label for="phone">{challenge.description}</label>
                        <input type="text" class="form-control tenant-info" value={selectedMFA} name={challenge.name} placeholder="Answer to question" id="name" onChange={this.handleAnswerChange.bind(self, challenge)}/>
                    </div>
                </div>
                )
            }
        });
        
        const toggleInstantVerification = () => this.setState({ instantVerification: !instantVerification })

        return (
            <div>
            <div class="row">
                <div class="col-md-2 col-sm-12 col-xs-12"></div>
                <div class="col-md-4 col-sm-6 col-xs-6">
                    <SelectableCard
                        onClick={ toggleInstantVerification }
                        color="blue"
                        iconClass="pe-7s-gleam"
                        title="Instant Verificiation"
                        optionCount={2}
                        selected={instantVerification}
                    />
                </div>
                <div class="col-md-4 col-sm-6 col-xs-6">
                    <SelectableCard
                        onClick={ toggleInstantVerification }
                        color="blue"
                        iconClass="icon-pen"
                        title="Manual Verification"
                        optionCount={2}
                        selected={!instantVerification}
                    />
                </div>
            </div>
            <div class="row blue-bottom-margin">
                <p style={{textAlign: 'center'}}><small>Payments take 3 - 4 business days to process.</small></p>
                <div class="content">
                    <form>
                    { instantVerification == true ? (
                    <div>
                    <div class="col-md-6 col-sm-12">
                        <div class="row">
                            <div class="header">
                                <span class="info-box-icon blue-icon-circle"><i class="icon-money-house-outline"></i></span>
                                <h4 class="title" style={{marginTop: '17px', marginLeft: '10px', float: 'left'}}>Bank Information</h4>
                                <p class="category"></p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-8 col-sm-12 col-xs-12">
                                <div class="form-group">
                                    <label for="phone">Banking label</label>
                                    <input type="text" value={bankName} class="form-control tenant-info" name="name" placeholder="Primary Checking" id="name" onChange={this.handleBankNameChange.bind(this)}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="row">
                            <div class="header">
                                <span class="info-box-icon blue-icon-circle"><i class="icon-bank"></i></span>
                                <h4 class="title" style={{marginTop: '17px', marginLeft: '10px', float: 'left'}}>Link Bank through Instant Verification</h4>
                                <p class="category"></p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-8 col-sm-12 col-xs-12">
                                <div class="form-group">
                                    <label for="phone">Search your bank</label>
                                    <input type="text" value={searchString} class="form-control tenant-info" placeholder="Chase Bank" onChange={this.filterInstitutions.bind(this)}/>
                                </div>
                            </div>
                            <div class="col-md-12 filter-container" style={{display: displayInstitutions}}>
                                <ul>
                                    {filteredOptionsHTML}
                                </ul>
                            </div>
                        </div>
                        { bankingForm && (
                        <Modal
                        isOpen={showModal}
                        onRequestClose={this.handleCloseModal.bind(this, true)}
                        style={modalStyles.getModalStyles()}
                        ariaHideApp={false}
                        >
                            <div class="col-md-12 col-sm-12 col-xs-12">
                                <div class="row">
                                    <div class="header">
                                        <span class="info-box-icon blue-icon-circle"><i class="pe-7s-lock"></i></span>
                                        <h4 class="title" style={{marginTop: '30px', marginLeft: '10px', float: 'left'}}>Log into {bankingForm.name}</h4>
                                        <p class="category"></p>
                                    </div>
                                </div>
                                { mfa != null && mfa.length > 0 ? (
                                    <div class="row">
                                        { mfaHTML }
                                        { mfaSubmitHTML }
                                    </div>
                                ) : (
                                    bankAccounts.length > 0 ? (
                                    <div class="row">
                                        <div class="col-md-12 col-sm-12 col-xs-12" style={{paddingLeft: '0px'}}>
                                            <div class="form-group">
                                                <label for="phone">Choose a bank account</label>
                                                <select class="form-control" value={selectedBankAccount} onChange={this.selectBankAccount.bind(this)}>
                                                    <option value='0'>Select an account</option>
                                                    {bankAccountsHTML}
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-12 col-sm-12 col-xs-12" style={{paddingLeft: '0px'}}>
                                            <div class="form-group">
                                                <label for="phone">What type of account is this?</label>
                                                <select class="form-control" value={bankAccountType} onChange={this.selectBankAccountType.bind(this)}>
                                                    <option value='CHECKING'>Checking</option>
                                                    <option value='SAVINGS'>Savings</option>
                                                    <option value='BUSINESS'>Business</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-8 col-md-offset-4 col-sm-8 col-sm-offset-4 col-xs-8 col-xs-offset-3">
                                            <button type="button" id="save-tenant" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill pull-center" autoComplete="off" onClick={this.didSelectAccount.bind(this)}>
                                            Select Account
                                            </button>
                                            <div class="clearfix"></div>
                                        </div>
                                    </div>
                                    ) : (
                                    <div class="row">
                                        <form>
                                        <div class="col-md-12 col-sm-12 col-xs-12" style={{paddingLeft: '0px'}}>
                                            <div class="form-group">
                                                <label for="phone">{bankingForm.login_form[0].description}</label>
                                                <input type="text" value={username} class="form-control tenant-info" placeholder="User ID" onChange={this.handleUsernameChange.bind(this, bankingForm.login_form[0].name)}/>
                                            </div>
                                        </div>
                                        <div class="row"></div>
                                        <div class="col-md-12 col-sm-12 col-xs-12" style={{paddingLeft: '0px'}}>
                                            <div class="form-group">
                                                <label for="phone">{bankingForm.login_form[1].description}</label>
                                                <input type="password" value={password} class="form-control tenant-info" placeholder="" onChange={this.handlePasswordChange.bind(this, bankingForm.login_form[1].name)}/>
                                            </div>
                                        </div>
                                        <div class="col-md-8 col-md-offset-4 col-sm-8 col-sm-offset-4 col-xs-8 col-xs-offset-4">
                                            <button type="button" id="save-tenant" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill pull-center" autoComplete="off" onClick={this.authInstitution.bind(this)}>
                                            Login
                                            </button>
                                            <div class="clearfix"></div>
                                        </div>
                                        </form>
                                    </div>
                                    )
                                )}
                            </div>
                        </Modal>
                        )}
                    </div>
                    <div>
                        {choosenBankAccount != null && choosenBankAccount.length > 0 && (
                        <div class="row">
                            <div class="col-md-4 col-sm-8 col-xs-12 col-md-offset-4">
                                <div class="info-box">
                                    <span class="info-box-icon blue-icon-circle"><i class="pe-7s-plug"></i></span>
                                    <div class="info-box-content">
                                        <label>Selected bank account</label>
                                        <br/>
                                        <span class="info-box-text">
                                            { choosenBankAccount[0].name }<small></small>
                                        </span>
                                        <br/>
                                        <div class="category">
                                            <strong>{choosenBankAccount[0].account}</strong>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        )}
                        </div>
                    </div>
                    ) : (
                        <div class="col-md-8 col-sm-12 col-xs-12 col-md-offset-2">
                            <div class="row">
                                <div class="header">
                                    <span class="info-box-icon blue-icon-circle"><i class="icon-bank"></i></span>
                                    <h4 class="title" style={{marginTop: '30px', marginLeft: '10px', float: 'left'}}>Manually Link Bank Account</h4>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12 col-sm-12 col-xs-12">
                                    <div class="form-group">
                                        <label for="phone">Banking label</label>
                                        <input type="text" value={bankName} class="form-control tenant-info" name="name" placeholder="Primary Checking" id="name" onChange={this.handleBankNameChange.bind(this)}/>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-5 col-sm-6 col-xs-12">
                                    <div class="form-group">
                                        <label for="phone">Routing Number</label>
                                        <input type="text" value={routing} class="form-control tenant-info" name="routing" placeholder="Routing Number" id="routing" onChange={this.handleRoutingChange.bind(this)}/>
                                    </div>
                                </div>
                                <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-2">
                                    <div class="form-group">
                                        <label for="phone">Account Number</label>
                                        <input type="text" value={account} class="form-control tenant-info" name="account" placeholder="Account Number" id="account" onChange={this.handleAccountChange.bind(this)}/>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12 col-sm-12 col-xs-12">
                                    <div class="form-group">
                                        <label for="phone">What type of account is this?</label>
                                        <select class="form-control" value={bankAccountType} onChange={this.selectBankAccountType.bind(this)}>
                                            <option value='CHECKING'>Checking</option>
                                            <option value='SAVINGS'>Savings</option>
                                            <option value='BUSINESS'>Business</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    </form>
                </div>
                <div class="row">
                </div>
            </div>
            <div class="row blue-bottom" style={{marginLeft:"-50px"}}>
                <div class="blue-bottom-center-align">
                    <div class="col-md-12">
                        <button type="button" id="save-tenant" data-loading-text="Loading..." class="btn btn-info btn-fill" autoComplete="off" onClick={this.addBankAccount.bind(this)} disabled={addBankAccountDisabled}>
                        Add Bank Account
                        </button>
                        <div class="clearfix"></div>
                    </div>
                </div>
            </div>
            </div>
        );
    }
};


// WEBPACK FOOTER //
// app/components/Billing/AddBankAccountForm.jsx